<template>
  <div class="wrapper">
    <div class="main visual-2">
      <Header :backRoute="'/'" />
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-7 col-sm-12">
            <div class="vis2-cntnt">
              <h1>Embrace a Healthy Lifestyle</h1>
              <h3>Start Your Healthy Lifestyle Today</h3>
              <ul class="srvs" v-if="user.objectType === 'hospital' || user.objectType === 'super-admin' || user.objectType === 'admin'">
                <router-link to="/appointment-approval" class="srv-4">
                  <li>
                    <div>
                      <img src="@/assets/img/new-icn-4.png" alt="Walk-In" />
                      <p>Appointment Requests</p>
                    </div>
                  </li>
                </router-link>
                <router-link to="/manage-appointments" class="srv-2">
                  <li>
                    <div>
                      <img
                        src="@/assets/img/new-icn-2.png"
                        alt="Book an Appointment"
                      />
                      <p>Manage Appointments</p>
                    </div>
                  </li>
                </router-link>
                <router-link to="/queue-counter" class="srv-1">
                  <li>
                    <div>
                      <img
                        src="@/assets/img/new-icn-1.png"
                        alt="Emergency services"
                      />
                      <p>Queue Counter</p>
                    </div>
                  </li>
                </router-link>
                <router-link to="/hospital-settings" class="srv-3">
                  <li>
                    <div>
                      <img
                        src="@/assets/img/new-icn-3.png"
                        alt="Telemedicine"
                      />
                      <p>Manage Doctors</p>
                    </div>
                  </li>
                </router-link>
              </ul>
              <ul class="srvs" v-else>
                <router-link to="/chose-option" class="srv-4">
                  <li>
                    <div>
                      <img src="@/assets/img/new-icn-4.png" alt="Walk-In" />
                      <p>Walk-In</p>
                    </div>
                  </li>
                </router-link>
                <router-link to="/verify-appointment" class="srv-2">
                  <li>
                    <div>
                      <img
                        src="@/assets/img/new-icn-2.png"
                        alt="Book an Appointment"
                      />
                      <p>Appointments</p>
                    </div>
                  </li>
                </router-link>
                <li @click="getQID">
                  <router-link to="#" class="srv-3">
                    <div>
                      <img
                        src="@/assets/img/new-icn-3.png"
                        alt="Telemedicine"
                      />
                      <p>Get Q-ID</p>
                    </div>
                  </router-link>
                </li>

                <router-link to="/about-hospital" class="srv-1">
                  <li>
                    <div>
                      <img
                        src="@/assets/img/new-icn-1.png"
                        alt="Emergency services"
                      />
                      <p>Information</p>
                    </div>
                  </li>
                </router-link>
              </ul>
            </div>
          </div>
          <div class="col-lg-6 col-md-5 col-sm-12">
            <div class="doc main-scr-table">
              <!-- <div v-if="isLoading" class="loading">Loading...</div> -->

              <div
                v-if="appointments.find((a) => a.status === 'waiting')"
                class="upc-patient"
              >
                <label class="">
                  <i class="fa-solid fa-circle-chevron-right"></i> Next:
                </label>
                <div class="upc-patient-name">
                  {{
                    $formatName(
                      appointments.find((a) => a.status === "waiting")?.patient
                    )
                  }}
                  Please proceed toward the counter.
                </div>
              </div>

              <div v-if="error" class="error-message">{{ error }}</div>
              <div class="table-wrapper" v-else>
                <table>
                  <thead>
                    <tr>
                      <th>Patient Name</th>
                      <th>Q-ID</th>
                      <th>EstimatedTime</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- Iterate through appointments data -->
                    <tr
                      v-for="appointment in appointments"
                      :key="appointment.id"
                    >
                      <td>
                        <router-link
                          :to="'/appointment-status?id=' + appointment.id"
                          class="srv-4"
                        >
                          <p>
                            {{ $formatName(appointment?.patient) }}
                          </p>
                        </router-link>
                      </td>

                      <td>{{ appointment?.qid }}</td>
                      <td>
                        {{
                          appointment.status === "waiting"
                            ? appointment.humanReadableEstimatedTime
                            : "-"
                        }}
                      </td>
                      <td>
                        <p :class="statusClass(appointment?.status)">
                          {{ appointment.status }}
                        </p>
                      </td>
                    </tr>
                    <!-- Show a message if no appointments are available -->
                    <tr v-if="appointments.length === 0">
                      <td colspan="4" class="text-center">
                        No appointments available
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterView :showButtons="true" />
    </div>
  </div>
</template>

<script>
import { PatientTimeSlotsService } from "@/services/patient-time-slots.service";
import FooterView from "../layout/Footer.vue";
import Header from "../layout/Header.vue";
export default {
  components: {
    FooterView, // Register locally
    Header,
  },
  name: "AppointmentsPage",
  data() {
    return {
      user: this.$store?.state?.user?.currentUser,
      appointments: [], // Store appointments data
      error: "", // To store any error messages
      isLoading: true, // Show loading state while fetching data
      refreshInterval: null, // Store the interval ID for clearing it later
    };
  },
  methods: {
    statusClass(status) {
      switch (status) {
        case "open":
          return "status-open";
        case "waiting":
          return "status-waiting";
        case "cancelled":
          return "status-cancelled";
        case "closed":
          return "status-closed";
        case "approved":
          return "status-approved";
        case "started":
          return "status-started";
        case "inprogress":
          return "status-inprogress";
        case "completed":
          return "status-completed";
        default:
          return "status-default"; // For unhandled statuses
      }
    },
    async fetchAppointments() {
      this.isLoading = true; // Start the loading spinner
      try {
        const response = await PatientTimeSlotsService.getList(false);
        this.appointments = response.data.content || []; // Store the list of appointments
        this.error = ""; // Clear any previous errors
      } catch (error) {
        console.log("🚀 ~ fetchAppointments ~ error:", error);
        this.error =
          error?.response?.data?.error?.message ||
          "Failed to load appointments"; // Handle any errors
      } finally {
        this.isLoading = false; // Stop the loading spinner
      }
    },
    getQID() {
      const today = new Date().toISOString().split("T")[0]; // Get current date (YYYY-MM-DD)
      const lastDate = localStorage.getItem("lastDate");
      let counter = parseInt(localStorage.getItem("patientCounter")) || 1;

      // Reset counter if the day has changed
      if (lastDate !== today) {
        counter = 1;
        localStorage.setItem("lastDate", today);
      }

      const patientData = {
        communicationType: "text",
        email: "",
        firstname: `Patient`,
        lastname: `${counter}`,
        phone: "",
      };

      // Store updated counter and patient data
      localStorage.setItem("patient", JSON.stringify(patientData));
      localStorage.setItem("patientCounter", counter + 1);

      this.$router.push("/available-doctor");
    },
  },
  mounted() {
    // Fetch appointments initially
    this.fetchAppointments();

    // Set an interval to re-fetch the data every 2 minutes (120,000 milliseconds)
    this.refreshInterval = setInterval(() => {
      this.fetchAppointments();
    }, 60000); // 60000 ms = 1 minutes
  },
  beforeUnmount() {
    // Clear the interval when the component is destroyed
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  },
};
</script>

<style scoped>
/* Place the styles here */
.modal {
  display: none;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 1000;
  /* Sit on top */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  background-color: rgba(0, 0, 0, 0.7);
  /* Black w/ opacity */
  justify-content: center;
  align-items: center;
}

.modal-content {
  background-color: white;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 300px;
  text-align: center;
  border-radius: 10px;
}

.modal-content h4 {
  color: red;
}

.close-btn {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  border-radius: 5px;
}

.close-btn:hover {
  background-color: #0056b3;
}
</style>
